import { render, staticRenderFns } from "./NominatorList.vue?vue&type=template&id=2e246108&"
import script from "./NominatorList.vue?vue&type=script&lang=js&"
export * from "./NominatorList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports